import { UserProfile } from '../../components/user-profile';

export const Profile = () => {
  return <UserProfile />;
};
